import { Button, ButtonTheme } from '@apply/components';
import { MouseEventHandler } from 'react';

interface EnabledRequestDrawButtonProps {
    handleClick: MouseEventHandler<Element> | undefined;
}
export const EnabledRequestDrawButton = ({ handleClick }: EnabledRequestDrawButtonProps) => {
    return (
        <Button
            id='secondaryButton'
            theme={ButtonTheme.Secondary}
            width='160px'
            handleClick={handleClick}
        >
            Request Draw
        </Button>
    );
};
